import angular from 'angular';
import uiRouter from 'angular-ui-router';

import NewMessageComponent from './new.component';

const newMessageModule = angular.module('tinaba.components.messageOutbound.new', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('messageOutbound.new', {
    url: '/new',
    template: '<new-message></new-message>'
  });
})

.component('newMessage', NewMessageComponent);

export default newMessageModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/new/new.js
 **/